import {
    Container,
    Flex,
    Heading,
    Text,
    Stack,
    StackDivider,
    Icon,
    useColorModeValue,
    Avatar,
    Box,
    Center,
    Button,
    Badge,
    keyframes,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { DiDatabase } from "react-icons/di";
import { MdOutlineSyncProblem } from "react-icons/md";
import { GiSkills } from "react-icons/gi";
import { FaDownload, FaGithub } from "react-icons/fa";
import Resume from "../Components/Akshay_Bombatkar_Resume.pdf";

const fadeInUp = keyframes`
    from { opacity: 0; transform: translateY(30px); }
    to { opacity: 1; transform: translateY(0); }
`;

const fadeInLeft = keyframes`
    from { opacity: 0; transform: translateX(-30px); }
    to { opacity: 1; transform: translateX(0); }
`;

const fadeInRight = keyframes`
    from { opacity: 0; transform: translateX(30px); }
    to { opacity: 1; transform: translateX(0); }
`;

const float = keyframes`
    0%, 100% { transform: translateY(0px); }
    50% { transform: translateY(-10px); }
`;

const pulse = keyframes`
    0%, 100% { box-shadow: 0 0 0 0 rgba(66, 153, 225, 0.4); }
    50% { box-shadow: 0 0 0 15px rgba(66, 153, 225, 0); }
`;



const getData = async () => {
    const res = await fetch("https://api.github.com/users/bakshay96");
    return await res.json();
};

const Feature = ({ text, icon, iconBg, delay }) => {
    return (
        <Stack 
            direction={"row"} 
            align={"center"}
            animation={`${fadeInUp} 0.6s ease-out ${delay}s both`}
            _hover={{ transform: "translateX(10px)", transition: "transform 0.3s ease" }}
        >
            <Flex
                w={10}
                h={10}
                align={"center"}
                justify={"center"}
                rounded={"full"}
                bg={iconBg}
                transition="all 0.3s ease"
                _hover={{ transform: "scale(1.1) rotate(5deg)" }}
            >
                {icon}
            </Flex>
            <Text fontWeight={600}>{text}</Text>
        </Stack>
    );
};

const Home = () => {
    const [result, setResult] = useState({});
    const SkillArr = ['JAVASCRIPT', 'REACT', 'REDUX', 'NODE', 'EXPRESS', 'MONGO', 'REST API', 'GIT', 'POSTMAN']
    useEffect(() => {
        fetchData();
    }, []);


    const fetchData = async () => {
        try {
            const data = await getData();
            setResult(data);
        } catch (err) {
            console.log(err);
        }
    };

    const cardBg = useColorModeValue("blue.50", "blue.900");
    const dividerColor = useColorModeValue("gray.100", "gray.700");
    const bioColor = useColorModeValue("gray.700", "gray.400");
    const resumeBtnBg = useColorModeValue("blue.50", "blue.900");
    const resumeBtnHover = useColorModeValue("blue.100", "blue.800");
    const featureGreenBg = useColorModeValue("green.100", "green.900");
    const featurePurpleBg = useColorModeValue("purple.100", "purple.900");
    const featureYellowBg = useColorModeValue("yellow.100", "yellow.900");

    return (
        <Container maxW={"7xl"} m={"auto"} paddingTop="80px" id="home">
            <Flex
                direction={["column", "column", "row"]}
                justifyContent="space-between"
                alignItems={"center"}
                padding="20px"
                gap={"50px"}
            >
                <Stack spacing={4} w={["95%", "95%", "55%"]} m="auto" animation={`${fadeInLeft} 0.8s ease-out`}>
                    <Text
                        textTransform={"uppercase"}
                        color={"white.400"}
                        border="1px solid black"
                        fontWeight={600}
                        fontSize={"sm"}
                        bg={cardBg}
                        p={2}
                        alignSelf={"flex-start"}
                        rounded={"md"}
                        animation={`${fadeInUp} 0.6s ease-out 0.2s both`}
                    >
                        A MERN Stack Developer
                    </Text>
                    <Heading animation={`${fadeInUp} 0.6s ease-out 0.3s both`}>
                        Hi, I'm{" "}
                        <Box
                            as="span"
                            bgGradient="linear(to-r, #60A5FA, #8B5CF6)"
                            bgClip="text"
                            fontWeight="extrabold"
                        >
                            Akshay Bombatkar
                        </Box>
                    </Heading>
                    <Text 
                        color={"gray.500"} 
                        fontSize={"lg"}
                        animation={`${fadeInUp} 0.6s ease-out 0.4s both`}
                        lineHeight="tall"
                    >
                        A highly motivated and adaptable individual with a passion for
                        implementing technical and logical skills in the creative
                        domain. Specializes in quickly learning new skills and tech
                        stacks, problem-solving, responsive design principles, and
                        teamwork. Aspires to build a career in an organization with
                        dedicated people that aligns with their career goals.
                    </Text>
                    <Stack
                        spacing={4}
                        mt={8}
                        divider={
                            <StackDivider
                                borderColor={dividerColor}
                            />
                        }
                    >
                        <Feature
                            icon={
                                <Icon
                                    as={MdOutlineSyncProblem}
                                    color={"green.500"}
                                    w={5}
                                    h={5}
                                />
                            }
                            iconBg={featureGreenBg}
                            text={"Problem Solving Mindset"}
                            delay={0.5}
                        />
                        <Feature
                            icon={<Icon as={GiSkills} color={"purple.500"} w={5} h={5} />}
                            iconBg={featurePurpleBg}
                            text={"Soft Skills & Tech Skills"}
                            delay={0.6}
                        />
                        <Feature
                            icon={<Icon as={DiDatabase} color={"yellow.500"} w={5} h={5} />}
                            iconBg={featureYellowBg}
                            text={"Data Structure & Algorithm"}
                            delay={0.7}
                        />
                    </Stack>
                </Stack>

                <Flex 
                    animation={`${fadeInRight} 0.8s ease-out`}
                    w={{ base: "100%", md: "auto" }}
                    justify={{ base: "center", md: "flex-start" }}
                >
                    <Center py={{ base: 4, md: 6 }} px={{ base: 2, md: 0 }}>
                        <Box
                            maxW={{ base: "320px", sm: "380px", md: "420px" }}
                            w={{ base: "90%", sm: "full" }}
                            bg={useColorModeValue("white", "gray.800")}
                            border="1px solid"
                            borderColor={useColorModeValue("gray.200", "gray.700")}
                            rounded={"2xl"}
                            p={{ base: 6, md: 8 }}
                            boxShadow="0 20px 40px rgba(0,0,0,0.1)"
                            textAlign={"center"}
                            height="auto"
                            animation={`${float} 3s ease-in-out infinite`}
                            transition="all 0.3s ease"
                            _hover={{
                                transform: "translateY(-10px)",
                                boxShadow: "0 30px 60px rgba(0,0,0,0.15)"
                            }}
                        >
                            <Box position="relative" display="inline-block">
                                <Avatar
                                    size={{ base: "xl", md: "2xl" }}
                                    src={result.avatar_url}
                                    alt={"Akshay Bombatkar"}
                                    mb={4}
                                    border="4px solid"
                                    borderColor={useColorModeValue("#60A5FA", "#3B82F6")}
                                    animation={`${pulse} 2s infinite`}
                                    transition="all 0.3s ease"
                                    _hover={{ transform: "scale(1.05)" }}
                                />
                                <Box
                                    position="absolute"
                                    bottom="15%"
                                    right="5%"
                                    w={{ base: 3, md: 4 }}
                                    h={{ base: 3, md: 4 }}
                                    bg="green.400"
                                    border="2px solid white"
                                    rounded="full"
                                    animation={`${pulse} 2s infinite`}
                                />
                            </Box>
                            <Heading fontSize={{ base: "lg", md: "2xl" }} fontFamily={"body"}>
                                {result.name}
                            </Heading>
                            <Text fontWeight={600} color={"gray.500"} mb={4} fontSize={{ base: "sm", md: "md" }}>
                                {`@${result.login}`}
                            </Text>
                            <Text
                                textAlign={"center"}
                                color={bioColor}
                                px={3}
                                fontSize={{ base: "sm", md: "md" }}
                                fontStyle="italic"
                                noOfLines={3}
                            >
                                {result.bio}
                            </Text>
                            <Stack
                                align={"center"}
                                justify={"center"}
                                direction={"row"}
                                mt={6}
                                display="flex"
                                flexWrap={"wrap"}
                                gap="8px"
                            >
                                {SkillArr.map((ele, idx) => (
                                    <Badge
                                        key={idx}
                                        px={{ base: 2, md: 3 }}
                                        py={1}
                                        fontSize={{ base: "xs", md: "sm" }}
                                        fontWeight={"500"}
                                        colorScheme="blue"
                                        variant="subtle"
                                        borderRadius="full"
                                        animation={`${fadeInUp} 0.4s ease-out ${0.8 + idx * 0.05}s both`}
                                        _hover={{
                                            transform: "scale(1.1)",
                                            transition: "transform 0.2s"
                                        }}
                                    >
                                        {ele}
                                    </Badge>
                                ))}
                            </Stack>

                            <Stack mt={8} direction={{ base: "column", sm: "row" }} spacing={4}>
                                <Button
                                    flex={1}
                                    fontSize={{ base: "xs", md: "sm" }}
                                    rounded={"full"}
                                    color={"white.400"}
                                    bg={resumeBtnBg}
                                    leftIcon={<FaDownload size={14} />}
                                    _hover={{
                                        bg: resumeBtnHover,
                                        transform: "translateY(-2px)",
                                        boxShadow: "lg"
                                    }}
                                    _active={{ transform: "translateY(0)" }}
                                    transition="all 0.3s ease"
                                    size={{ base: "sm", md: "md" }}
                                >
                                    <a
                                        href={Resume}
                                        target="_blank"
                                        rel="noreferrer"
                                        onClick={() => window.open(
                                            "https://drive.google.com/file/d/1GOj_2HXTBDILQ1xfynzR-T8wWc0mRbkH/view?usp=drive_link",
                                            "_blank"
                                        )}
                                        download="Akshay-Bombatkar-Resume"
                                    >
                                        Resume
                                    </a>
                                </Button>

                                <Button
                                    flex={1}
                                    fontSize={{ base: "xs", md: "sm" }}
                                    rounded={"full"}
                                    bg={"#3B82F6"}
                                    color={"white"}
                                    leftIcon={<FaGithub size={14} />}
                                    _hover={{
                                        bg: "blue.600",
                                        transform: "translateY(-2px)",
                                        boxShadow: "lg"
                                    }}
                                    _active={{ transform: "translateY(0)" }}
                                    transition="all 0.3s ease"
                                    size={{ base: "sm", md: "md" }}
                                >
                                    <a 
                                        href={result.html_url}
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        Follow
                                    </a>
                                </Button>
                            </Stack>
                        </Box>
                    </Center>
                </Flex>
            </Flex>
        </Container>
    );
}
export default Home;